import { Record } from "immutable"

import { updateCreateModel } from "../model-utils"

const tagFields = ["countries", "regions", "greater_regions"]

export const SourceFilterModel = new Record({
    name: "",
    type: "",
    active: "",
    publication_type: "",
    content_type: "",
    countries: [],
    regions: [],
    greater_regions: [],
    license: ""
})

export const updateSourceSearchFilterModel = (
    name,
    value,
    searchFilterModel,
    workingFilterModel
) =>
    updateCreateModel(
        name,
        value,
        searchFilterModel,
        workingFilterModel,
        tagFields
    )
